
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './utils/buildInfo'
import { initializeTheme, setupThemeListener } from './utils/themeManager'

// Initialize theme based on system preferences
initializeTheme();
setupThemeListener();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
